import { c as _c } from "react/compiler-runtime";
import { Centre, Text, VStack } from '@jaaq/hub-ui';
import type { ReactElement } from 'react';
type ActionCardProps = {
  icon: React.ReactNode;
  title: string;
  description?: string;
  onClick: () => void;
};
export const ActionCard = t0 => {
  const $ = _c(13);
  const {
    icon,
    title,
    description,
    onClick
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <Centre className="size-12 rounded-lg bg-black/5 shrink-0">{icon}</Centre>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <Text as="span" variant="body-lg" className="font-bold">{title}</Text>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = description && <Text as="span" variant="body" className="mt-1 text-jaaq-grey-600">{description}</Text>;
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <VStack>{t2}{t3}</VStack>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onClick || $[10] !== t1 || $[11] !== t4) {
    t5 = <button type="button" onClick={onClick} className="bg-surface rounded-xl w-full flex items-center gap-4 px-5 py-5 text-left hover:bg-white/95 transition-colors">{t1}{t4}</button>;
    $[9] = onClick;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};